"use client";

import { useEffect, useState } from "react";

import {
  GAM_HOME_DESKTOP_BANNER_AD_UNIT,
  GAM_HOME_DESKTOP_BANNER_ENABLED,
  GAM_HOME_DESKTOP_BANNER_MIN_HEIGHT,
  GAM_HOME_DESKTOP_BANNER_SIZES,
} from "@/components/ads/config";

import GamDisplaySlot from "./GamDisplaySlot";
import styles from "./WideBannerAd.module.css";

const LAPTOP_QUERY = "(min-width: 1200px)";

export default function HomeDesktopBannerAd() {
  const [show, setShow] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia(LAPTOP_QUERY);
    const update = () => setShow(mediaQuery.matches);

    update();
    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, []);

  if (!GAM_HOME_DESKTOP_BANNER_ENABLED || show !== true) return null;

  return (
    <div className={styles.wrap} data-home-desktop-banner="true">
      <div className={styles.inner}>
        <div className={styles.header}>
          <span className={styles.label}>Sponsored</span>
        </div>

        <GamDisplaySlot
          id="home-desktop-banner"
          adUnit={GAM_HOME_DESKTOP_BANNER_AD_UNIT}
          sizes={[...GAM_HOME_DESKTOP_BANNER_SIZES]}
          minHeight={GAM_HOME_DESKTOP_BANNER_MIN_HEIGHT}
          targeting={{
            page_type: "home",
            device: "laptop_desktop",
            placement: "home_desktop_banner_below_hero",
            position: "below_hero",
          }}
        />
      </div>
    </div>
  );
}
